import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";
import { BaseService } from "../../@core/services/base.service";
import { IShareContract, IShareUser, IUser, SHARE_ACCESS, SHARE_FEATURE } from "../../@core/models/model";

@Injectable({ providedIn: 'root', })
export class ShareService extends BaseService {
    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    shareUrl = environment.apiUrl + '/share'

    isShareUserHaveAccess(user: Partial<IUser>, resource?: string, feature?: SHARE_FEATURE) {
        return this.post<{
            hasAccess: boolean,
            isOrgAdmin: boolean,
        }>(this.shareUrl + `/share-user-have-access`, { user, resource, feature })
    }

    giveAccessToShareUser(user: Partial<IShareUser>, resource: string, feature: SHARE_FEATURE) {
        return this.post<{
            hasAccess: boolean,
        }>(this.shareUrl + `/give-access-to-share-user`, { user, resource, feature })
    }

}